import React, { Component } from 'react';
import "@fortawesome/fontawesome-free/css/all.css";
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';

const icon = "menuUser"
const roles = ["View", "Add", "Edit", "Delete"]

class Users extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			time: new Date(),
			type: "users",
			filterBy: {},
			sortBy: '',
			sortOrder: 1,
			resetUserPIN: '',
			rolesToAdd: [],
			rolesToRemove: [],
			error: false,
			editSettings: false,
			tab: 'features'
		};
	}

	//Whole Page
	cancel = () => {
		this.setState({ editing: false, deleting: false, settingEdits: false, changingStatus: false, resetting: false, unlocking: false, editingRoles: false, loading: false, error: false })
	}
	checkType = (e) => {
		console.log(e.target.value)
		this.setState({ type: e.target.value })
	}
	filter = (field) => (e) => {
		var filterBy = this.state.filterBy
		if (e.target.value.length > 0) {
			filterBy[field] = e.target.value
		} else {
			delete filterBy[field]
		}
		this.setState({ filterBy: filterBy })
	}
	sort = (sortBy) => (e) => {
		var sortOrder
		if (this.state.sortOrder === -1) {
			sortOrder = 1;
		} else {
			sortOrder = -1;
		}
		this.setState({ sortBy: sortBy, sortOrder: sortOrder })
	}
	sortFunc(sortBy, sortOrder) {
		return function (a, b) {
			if (sortBy === "status" || sortBy === "ActivityDateTime") {
				if ('status' in a && 'status' in b) {
					if (!a.loggedIn && !b.loggedIn) {
						return a.username > b.username ? 1 * sortOrder : -1 * sortOrder
					} else if (!a.loggedIn) {
						return 1
					} else if (!b.loggedIn) {
						return -1
					}
					if (a[sortBy] === b[sortBy]) {
						return a.username > b.username ? 1 * sortOrder : -1 * sortOrder
					}
					return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
				} else {
					if ('status' in a) {
						return -1
					}
					return 1
				}
			}

			if (sortBy in a && sortBy in b) {
				if (a[sortBy] === b[sortBy]) {
					return a.email > b.email ? 1 * sortOrder : -1 * sortOrder
				}
				return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
			} else if (!(sortBy in a) && !(sortBy in b)) {
				return a.email > b.email ? 1 * sortOrder : -1 * sortOrder
			} else {
				return sortBy in a ? -1 : 1
			}
		}
	}
	filterFunc(array, filterBy) {
		return array.filter(function (object) {
			for (var prop in filterBy) {
				if (typeof object[prop] === "undefined") {
					return false
				}
				if (object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
					return false
				}
			}
			return true
		})
	}
	filterIcon(item) {
		return (this.state.sortBy === item ? (this.state.sortOrder == 1) ? " \u25B2" : " \u25BC" : "")
	}
	componentWillReceiveProps(nextProps) {
		if (this.state.loading) {
			this.cancel()
		}
	}
	componentDidMount = () => {
		this.timerTick = setInterval(() => {
			if (this.props.active) {
				this.setState({ time: new Date() })
			}
		}, 1000);
	}

	//Manage Users


	userAdd = (e) => {
		this.setState({
			editing: {
				id: null, email: "", firstName: "", lastName: "", wholeName: "", password: "", failedAttempts: 0, roles: { "default": true }, queues: {}, loggedIn: false, oldPasswords: [], passwordUpdated: "", userID: "", accessCode: "", ActivityDateTime: "",
				status: ""
			}
		})
	}
	userEdit = (user) => (e) => {
		this.setState({ editing: this.props.data.Users.Users[user] })
	}
	userValueChange = (field) => (e) => {
		var editing = JSON.parse(JSON.stringify(this.state.editing))
		editing[field] = e.currentTarget.value
		this.setState({ editing: editing })
	}
	userConfirm = () => {
		if (this.state.editing.email.toString().length < 1 || !(/[^@]+@[^\.]+\..+/gm.test(this.state.editing.email))) {
			this.setState({ error: 'Please enter a valid email address.' });
		} else if (this.state.editing.firstName.toString().length < 1) {
			this.setState({ error: "Please enter the user's first name." });
		} else if (this.state.editing.lastName.toString().length < 1) {
			this.setState({ error: "Please enter the user's last name." });
		} else if ((this.state.editing.phoneNumber) && (this.state.editing.phoneNumber.toString().length < 1)) {
			this.setState({ error: "Please enter the user's Phone Number" });
		} else if (this.state.editing.userID && (this.state.editing.userID.toString().length < 4 || this.state.editing.userID.toString().length > 10)) {
			this.setState({ error: 'UserID must be between 4-10 digits.' });
		} else if (this.state.editing.accessCode && (this.state.editing.accessCode.toString().length < 4 || this.state.editing.accessCode.toString().length > 10)) {
			this.setState({ error: 'Access Code must be at between 4-10 digits.' });
		} else if (this.state.editing.phoneNumber && (this.state.editing.phoneNumber.toString().length != 10)) {
			this.setState({ error: 'Phone Number must be 10 digits.' });
		} else if (!this.state.editing.userID && this.state.editing.accessCode) {
			this.setState({ error: 'Enter a User ID, or remove Access Code.' });
		} else if (this.state.editing.userID && !this.state.editing.accessCode) {
			this.setState({ error: 'Enter an Access Code, or remove User ID.' });
		} else if (this.state.editing.userID && this.state.editing.accessCode && this.state.editing.userID == this.state.editing.accessCode) {
			this.setState({ error: 'User ID and Access Code must be different.' });
		} else {
			this.setState({ loading: true });
			if (this.state.editing.id) {
				this.props.ws.send(JSON.stringify({ route: 'editUser', user: this.state.editing }))
			} else {
				this.props.ws.send(JSON.stringify({ route: 'addUser', user: this.state.editing }))
			}
		}
	}

	//Unlock User
	userUnlock = (user) => (e) => {
		this.setState({ unlocking: user })
	}
	userConfirmUnlock = () => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({ route: 'unlockUser', user: this.state.unlocking }))
	}


	//Reset User Password
	resetUser = (user) => (e) => {
		this.setState({ resetting: user, resetUserPIN: '' })
	}
	resetUserPINChange = (e) => {
		if (e.target.value.length < 1) {
			this.setState({ resetUserPIN: '', error: 'Enter a new password for this user.' });
		} else {
			this.setState({ resetUserPIN: e.target.value, error: '' });
		}
	}
	confirmResetUser = () => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({ route: 'resetUser', user: this.state.resetting, resetUserPIN: this.state.resetUserPIN }))
	}


	//Manage Roles
	changeRoles = (user) => (e) => {
		this.setState({ editingRoles: user, rolesToAdd: [], rolesToRemove: [] });
	}
	addRole = (role) => (e) => {
		var rolesToAdd = this.state.rolesToAdd.slice()
		var rolesToRemove = this.state.rolesToRemove.slice()
		rolesToAdd.push(role)
		if (rolesToRemove.indexOf(role) > -1) {
			rolesToRemove.splice(rolesToRemove.indexOf(role), 1)
		}
		this.setState({ rolesToAdd: rolesToAdd, rolesToRemove: rolesToRemove })
	}
	removeRole = (role) => (e) => {
		var rolesToAdd = this.state.rolesToAdd.slice()
		var rolesToRemove = this.state.rolesToRemove.slice()
		rolesToRemove.push(role)
		if (rolesToAdd.indexOf(role) > -1) {
			rolesToAdd.splice(rolesToAdd.indexOf(role), 1)
		}
		this.setState({ rolesToAdd: rolesToAdd, rolesToRemove: rolesToRemove })
	}
	confirmRoleChanges = () => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({ route: 'updateUserRoles', user: this.state.editingRoles, rolesToAdd: this.state.rolesToAdd, rolesToRemove: this.state.rolesToRemove }))
	}

	//Delete User
	deleteUser = (user) => (e) => {
		this.setState({ deleting: user })
	}
	confirmDeleteUser = () => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({ route: 'deleteUser', user: this.state.deleting }))
	}
	handleTabChange = (e) => {
		if (this.state.tab === "features") {
			this.setState({ tab: "passwords" })

		}
		else {
			this.setState({ tab: "features" })
		}
	}



	//Settings
	settingsToggleFeature = (featureKey) => {
		this.state.settingEdits.features[featureKey].enabled = !this.state.settingEdits.features[featureKey].enabled;
		this.setState({});
	};
	settingsToggleSetting = () => {
		if (!this.state.editSettings) {
			this.setState({
				editSettings: true,
				settingEdits: JSON.parse(JSON.stringify(this.props.data.Users.settings))
			})
		} else {
			this.setState({
				editSettings: false,
				settingEdits: {}
			})
		}
	}
	settingsPasswordChange = (settingKey, value) => {
		this.state.settingEdits.passwords[settingKey] = value;
		// Update the state if necessary
		this.setState({}); // Empty setState to
	}
	incrementPasswordSetting = (settingKey, oppositeKey) => {
		const { passwords } = this.state.settingEdits;
		//if the value does not exist set it to 0
		if (!passwords[settingKey]) {
			passwords[settingKey] = 0;
		}


		if (passwords[settingKey] >= 250) {
			// Max value reached, do nothing
			return;
		}


		passwords[settingKey] = parseInt(passwords[settingKey]) + 1;

		// Check if the opposite key crosses the current setting value
		if (oppositeKey && passwords[settingKey] > passwords[oppositeKey]) {
			passwords[oppositeKey] = passwords[settingKey];
		}

		// Update the state if necessary
		this.setState({});
	}

	decrementPasswordSetting = (settingKey, oppositeKey) => {
		const { passwords } = this.state.settingEdits;

		if (passwords[settingKey] <= 0) {
			// Min value reached, do nothing
			return;
		}

		passwords[settingKey] = passwords[settingKey] - 1;

		// Check if the opposite key crosses the current setting value
		if (oppositeKey && passwords[settingKey] < passwords[oppositeKey]) {
			passwords[oppositeKey] = passwords[settingKey];
		}

		// Update the state if necessary
		this.setState({});
	}






	settingsSave = () => {
		this.setState({ loading: true, editSettings: false });
		this.props.ws.send(JSON.stringify({ route: 'updateSettings', settings: this.state.settingEdits }))
	}


	render() {
		if (this.props.active) {
			//console.log(this.props)
			if (this.state.type === "" || this.state.type === undefined) {
				this.setState({ type: "user" })
			}

			var userList = []
			var editSettings = ""
			if (this.state.editSettings) {
				editSettings = (

					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
							<div className="viewCloser" onClick={this.settingsToggleSetting}></div>
							<div className="error">{this.state.error}</div>
							<div className="tab-header" style={{ display: 'flex', justifyContent: 'center' }}>
								<div
									className="tab"
									style={{
										padding: '10px',
										cursor: 'pointer',
										background: this.state.tab === 'features' ? '#2A6AA9' : '#fff',
										color: this.state.tab === 'features' ? '#fff' : '#2A6AA9',
										border: '1px solid #2A6AA9',
										flex: 1,
										textAlign: 'center'
									}}
									onClick={() => this.handleTabChange('features')}
								>
									<span style={{ color: this.state.tab === 'features' ? '#fff' : '#2A6AA9' }}>Features</span>
								</div>
								<div
									className="tab"
									style={{
										padding: '10px',
										cursor: 'pointer',
										background: this.state.tab === 'passwords' ? '#2A6AA9' : '#fff',
										color: this.state.tab === 'passwords' ? '#fff' : '#2A6AA9',
										border: '1px solid #2A6AA9',
										flex: 1,
										textAlign: 'center'
									}}
									onClick={() => this.handleTabChange('passwords')}
								>
									<span style={{ color: this.state.tab === 'passwords' ? '#fff' : '#2A6AA9' }}>Passwords</span>
								</div>
							</div>

							{this.state.tab === 'features' && (
								<div className="form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr', gridGap: '8px', padding: '20px' }}>
									{Object.keys(this.state.settingEdits.features).map((featureKey) => {
										const feature = this.state.settingEdits.features[featureKey];
										return (
											<div key={featureKey} style={{ display: 'flex', alignItems: 'center' }}>
												<input
													type="checkbox"
													checked={feature.enabled}
													onChange={(e) => this.settingsToggleFeature(featureKey, e.target.checked)}
												/>
												<span style={{ marginLeft: '8px' }}>{feature.name}</span>
											</div>
										);
									})}
								</div>
							)}


							{this.state.tab === 'passwords' && (
								<div className="form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr', gridGap: '8px', padding: '20px' }}>
									<div style={{ border: '1px solid #ccc', borderRadius: '5px', padding: '20px 40px 5px' }}>
										<div>
											<label style={{ fontWeight: 'bold', marginBottom: '10px' }}>Password Length</label>
											<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '180px', marginBottom: '10px', marginTop: '5px' }}>
												<div style={{ padding: '10px' }}>
													<label>Min.</label>
													<div style={{ display: 'flex', alignItems: 'center' }}>
														<button onClick={() => this.decrementPasswordSetting('minLength')} style={{ width: '30px', height: '30px', textAlign: 'center', backgroundColor: '#2A6AA9', borderStyle: 'none', color: '#ffffff', borderRadius: '5px', borderStyle: 'none', fontSize: '16px', cursor: 'pointer' }}>-</button>
														<input
															type="text"
															value={this.state.settingEdits.passwords.minLength || 0}
															onChange={(e) => this.settingsPasswordChange('minLength', e.target.value)}
															style={{ width: '40px', height: '30px', textAlign: 'center', borderRadius: '5px', fontSize: '18px', padding: '0 5px', borderStyle: 'none', border: 'none', fontWeight: 'bold', color: '#137' }}
														/>
														<button onClick={() => this.incrementPasswordSetting('minLength', 'maxLength')} style={{ width: '30px', height: '30px', textAlign: 'center', backgroundColor: '#2A6AA9', color: '#ffffff', borderStyle: 'none', borderRadius: '5px', fontSize: '16px', cursor: 'pointer' }}>+</button>
													</div>
												</div>
												<div style={{ padding: '10px' }}>
													<label>Max.</label>
													<div style={{ display: 'flex', alignItems: 'center' }}>
														<button onClick={() => this.decrementPasswordSetting('maxLength', 'minLength')} style={{ width: '30px', height: '30px', textAlign: 'center', backgroundColor: '#2A6AA9', color: '#ffffff', borderStyle: 'none', borderRadius: '5px', fontSize: '16px', cursor: 'pointer' }}>-</button>
														<input
															type="text"
															value={this.state.settingEdits.passwords.maxLength || 0}
															onChange={(e) => this.settingsPasswordChange('maxLength', e.target.value)}
															style={{ width: '40px', height: '30px', textAlign: 'center', borderRadius: '5px', fontSize: '18px', borderStyle: 'none', border: 'none', fontWeight: 'bold', color: '#137' }}
														/>
														<button onClick={() => this.incrementPasswordSetting('maxLength')} style={{ width: '30px', height: '30px', textAlign: 'center', backgroundColor: '#2A6AA9', color: '#ffffff', borderStyle: 'none', borderRadius: '5px', fontSize: '16px', cursor: 'pointer' }}>+</button>
													</div>
												</div>
											</div>
										</div>
									</div>

									<div style={{ border: '1px solid #ccc', borderRadius: '5px', padding: '20px 40px 5px' }}>
										<div>
											<label style={{ fontWeight: 'bold', marginBottom: '10px' }}>Password Age (Days)</label>
											<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '180px', marginBottom: '10px', marginTop: '5px' }}>
												<div style={{ padding: '10px' }}>
													<label>Min.</label>
													<div style={{ display: 'flex', alignItems: 'center' }}>
														<button onClick={() => this.decrementPasswordSetting('minAge')} style={{ width: '30px', height: '30px', textAlign: 'center', backgroundColor: '#2A6AA9', borderStyle: 'none', color: '#ffffff', borderRadius: '5px', borderStyle: 'none', fontSize: '16px', cursor: 'pointer' }}>-</button>
														<input
															type="text"
															value={this.state.settingEdits.passwords.minAge || 0}
															onChange={(e) => this.settingsPasswordChange('minAge', e.target.value)}
															style={{ width: '40px', height: '30px', textAlign: 'center', borderRadius: '5px', fontSize: '18px', padding: '0 5px', borderStyle: 'none', border: 'none', fontWeight: 'bold', color: '#137' }}
														/>
														<button onClick={() => this.incrementPasswordSetting('minAge', 'maxAge')} style={{ width: '30px', height: '30px', textAlign: 'center', backgroundColor: '#2A6AA9', color: '#ffffff', borderStyle: 'none', borderRadius: '5px', fontSize: '16px', cursor: 'pointer' }}>+</button>
													</div>
												</div>
												<div style={{ padding: '10px' }}>
													<label>Max.</label>
													<div style={{ display: 'flex', alignItems: 'center' }}>
														<button onClick={() => this.decrementPasswordSetting('maxAge', 'minAge')} style={{ width: '30px', height: '30px', textAlign: 'center', backgroundColor: '#2A6AA9', color: '#ffffff', borderStyle: 'none', borderRadius: '5px', fontSize: '16px', cursor: 'pointer' }}>-</button>
														<input
															type="text"
															value={this.state.settingEdits.passwords.maxAge || 0}
															onChange={(e) => this.settingsPasswordChange('maxAge', e.target.value)}
															style={{ width: '40px', height: '30px', textAlign: 'center', borderRadius: '5px', fontSize: '18px', borderStyle: 'none', border: 'none', fontWeight: 'bold', color: '#137' }}
														/>
														<button onClick={() => this.incrementPasswordSetting('maxAge')} style={{ width: '30px', height: '30px', textAlign: 'center', backgroundColor: '#2A6AA9', color: '#ffffff', borderStyle: 'none', borderRadius: '5px', fontSize: '16px', cursor: 'pointer' }}>+</button>
													</div>
												</div>
											</div>
										</div>
									</div>

									<div style={{ border: '1px solid #ccc', borderRadius: '5px', padding: '20px 40px 5px' }}>
										<div>
											<label style={{ fontWeight: 'bold', marginBottom: '10px' }}>Security</label>
											<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '180px', marginBottom: '10px', marginTop: '5px' }}>
												<div style={{ padding: '10px' }}>
													<label>Timeout (Minutes)</label>
													<div style={{ display: 'flex', alignItems: 'center' }}>
														<button onClick={() => this.decrementPasswordSetting('lockTimeout')} style={{ width: '30px', height: '30px', textAlign: 'center', backgroundColor: '#2A6AA9', borderStyle: 'none', color: '#ffffff', borderRadius: '5px', borderStyle: 'none', fontSize: '16px', cursor: 'pointer' }}>-</button>
														<input
															type="text"
															value={this.state.settingEdits.passwords.lockTimeout || 0}
															onChange={(e) => this.settingsPasswordChange('lockTimeout', e.target.value)}
															style={{ width: '40px', height: '30px', textAlign: 'center', borderRadius: '5px', fontSize: '18px', padding: '0 5px', borderStyle: 'none', border: 'none', fontWeight: 'bold', color: '#137' }}
														/>
														<button onClick={() => this.incrementPasswordSetting('lockTimeout')} style={{ width: '30px', height: '30px', textAlign: 'center', backgroundColor: '#2A6AA9', color: '#ffffff', borderStyle: 'none', borderRadius: '5px', fontSize: '16px', cursor: 'pointer' }}>+</button>
													</div>
												</div>
												<div style={{ padding: '10px' }}>
													<label>Failed Attempts</label>
													<div style={{ display: 'flex', alignItems: 'center' }}>
														<button onClick={() => this.decrementPasswordSetting('maxFailedAttempts')} style={{ width: '30px', height: '30px', textAlign: 'center', backgroundColor: '#2A6AA9', color: '#ffffff', borderStyle: 'none', borderRadius: '5px', fontSize: '16px', cursor: 'pointer' }}>-</button>
														<input
															type="text"
															value={this.state.settingEdits.passwords.maxFailedAttempts || 0}
															onChange={(e) => this.settingsPasswordChange('maxFailedAttempts', e.target.value)}
															style={{ width: '40px', height: '30px', textAlign: 'center', borderRadius: '5px', fontSize: '18px', borderStyle: 'none', border: 'none', fontWeight: 'bold', color: '#137' }}
														/>
														<button onClick={() => this.incrementPasswordSetting('maxFailedAttempts')} style={{ width: '30px', height: '30px', textAlign: 'center', backgroundColor: '#2A6AA9', color: '#ffffff', borderStyle: 'none', borderRadius: '5px', fontSize: '16px', cursor: 'pointer' }}>+</button>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div style={{ border: '1px solid #ccc', borderRadius: '5px', padding: '20px 40px 5px' }}>
										<div>
											<label style={{ fontWeight: 'bold', marginBottom: '10px' }}>Complexity</label>
											<div style={{ display: 'grid', gridGap: '10px', marginBottom: '10px', marginTop: '5px' }}>
												<div style={{ display: 'flex', alignItems: 'center' }}>
													<input
														type="checkbox"
														checked={this.state.settingEdits.passwords.uppercase}
														onChange={(e) => this.settingsPasswordChange('uppercase', e.target.checked)}
														style={{ marginRight: '5px' }}
													/>
													<label>Uppercase</label>
												</div>
												<div style={{ display: 'flex', alignItems: 'center' }}>
													<input
														type="checkbox"
														checked={this.state.settingEdits.passwords.lowercase}
														onChange={(e) => this.settingsPasswordChange('lowercase', e.target.checked)}
														style={{ marginRight: '5px' }}
													/>
													<label>Lowercase</label>
												</div>
												<div style={{ display: 'flex', alignItems: 'center' }}>
													<input
														type="checkbox"
														checked={this.state.settingEdits.passwords.number}
														onChange={(e) => this.settingsPasswordChange('number', e.target.checked)}
														style={{ marginRight: '5px' }}
													/>
													<label>Number</label>
												</div>
												<div style={{ display: 'flex', alignItems: 'center' }}>
													<input
														type="checkbox"
														checked={this.state.settingEdits.passwords.specialCharacter}
														onChange={(e) => this.settingsPasswordChange('specialCharacter', e.target.checked)}
														style={{ marginRight: '5px' }}
													/>
													<label>Special Character</label>
												</div>
											</div>
										</div>

									</div>


								</div>
							)}





							<div style={{ display: 'flex', justifyContent: 'space-between', padding: '20px' }}>
								<div className="error">{this.state.error}</div>

								{this.state.loading ? (
									<div className="loader"></div>
								) : (
									<div className="button confirm" onClick={this.settingsSave} title="Confirm Changes">
										Confirm
									</div>
								)}
							</div>
						</div >

					</div >

				);
			}


			var users = JSON.parse(JSON.stringify(this.props.data.Users.Users));
			//turn user object into array
			users = Object.keys(users).map(function (key) {
				return users[key];
			});

			// //Filtering List
			if (Object.keys(this.state.filterBy).length > 0) {
				users = this.filterFunc(users, this.state.filterBy)
			}
			// //Sorting List
			if (this.state.sortBy !== '') {
				users.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
			}
			//users = users.filter((user) => {
			//	return user.type === this.state.type
			//})

			for (var user of users) {
				// take the language array and replace the text with the proper code in languageCodes then make the array a string seperated by commas
				const cleanedUpDate = (user.ActivityDateTime == '') ? "Never" : (new Date(user.ActivityDateTime).toDateString() === new Date().toDateString()) ? 'Today' : new Date(user.ActivityDateTime).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });

				userList.push(
					<tr className="dataRow" onClick={this.userEdit(user.id)} key={user.id}>
						<td style={{ flex: '0 0 180px', textAlign: 'left' }}>{user.wholeName}</td>
						<td style={{ flex: '1 0 250px', textAlign: 'left' }}>{user.email.length > 25 ? `${user.email.slice(0, 7)}...@${user.email.slice(user.email.indexOf("@") + 1).length > 3 ? `${user.email.slice(user.email.indexOf("@") + 1).slice(0, 7)}...` : user.email.slice(user.email.indexOf("@") + 1)}` : user.email}</td>
						<td style={{ flex: '0 0 150px', textAlign: 'right', color: user.failedAttempts >= this.props.data.Users.settings.passwords.maxFailedAttempts ? 'red' : user.status === 'Online' ? 'green' : 'inherit', fontWeight: user.failedAttempts >= this.props.data.Users.settings.passwords.maxFailedAttempts ? 'bold' : 'normal' }}>

							{user.failedAttempts >= this.props.data.Users.settings.passwords.maxFailedAttempts ? "Locked" : user.status}

						</td>
						<td style={{ flex: '0 0 200px', textAlign: 'right' }}>{cleanedUpDate}</td>
					</tr>
				);
			}
			//filter user list by type 

			var editUser = ""
			if (this.state.editing) {
				editUser = (
					<div className="blackout">
						<div className="pop">
							<div className="viewCloser" onClick={this.cancel}></div>


							<div className="snazzyInputBox">
								<input
									className="textInput"
									type="text"
									required
									value={this.state.editing.email}
									onChange={this.userValueChange("email")}
								></input>
								<span className="inputBar"></span>
								<label className="textLabel">Email Address</label>
							</div>

							{!this.state.editing.id ? (
								<div className="snazzyInputBox">
									<input
										className="textInput"
										type="password"
										required
										value={this.state.editing.password}
										onChange={this.userValueChange("password")}
									></input>
									<span className="inputBar"></span>
									<label className="textLabel">Password</label>
								</div>
							) : (
								""
							)}

							<div className="snazzyInputBox">
								<input
									className="textInput"
									type="text"
									required
									value={this.state.editing.firstName}
									onChange={this.userValueChange("firstName")}
								></input>
								<span className="inputBar"></span>
								<label className="textLabel">First Name</label>
							</div>

							<div className="snazzyInputBox">
								<input
									className="textInput"
									type="text"
									required
									value={this.state.editing.lastName}
									onChange={this.userValueChange("lastName")}
								></input>
								<span className="inputBar"></span>
								<label className="textLabel">Last Name</label>
							</div>

							{this.props.features.twoFactor ? (
								<div className="snazzyInputBox">
									<input
										className="textInput"
										type="text"
										required
										value={this.state.editing.phoneNumber}
										onChange={this.userValueChange("phoneNumber")}
									></input>
									<span className="inputBar"></span>
									<label className="textLabel">Phone Number</label>
								</div>
							) : (
								""
							)}

							{this.props.features.tui ? (
								<div className="snazzyInputBox">
									<input
										className="textInput"
										type="text"
										required
										value={this.state.editing.userID}
										onChange={this.userValueChange("userID")}
									></input>
									<span className="inputBar"></span>
									<label className="textLabel">User ID (Optional)</label>
								</div>
							) : (
								""
							)}

							{this.props.features.tui ? (
								<div className="snazzyInputBox">
									<input
										className="textInput"
										type="password"
										required
										value={this.state.editing.accessCode}
										onChange={this.userValueChange("accessCode")}
									></input>
									<span className="inputBar"></span>
									<label className="textLabel">Access Code (Optional)</label>
								</div>
							) : (
								""
							)}

							{!this.state.editing.id ? (
								""
							) : (
								<div className="button-group" style={{ display: "flex" }}>
									<div
										className="button"
										style={{
											backgroundColor: this.state.editing.failedAttempts >= this.props.data.Users.settings.passwords.maxFailedAttempts ? "red" : "#2A6AA9",
											marginRight: "5px"
										}}
										onClick={this.state.editing.failedAttempts >= this.props.data.Users.settings.passwords.maxFailedAttempts ? this.userUnlock(this.state.editing) : this.resetUser(this.state.editing)}
										title={
											this.state.editing.failedAttempts >= this.props.data.Users.settings.passwords.maxFailedAttempts ? "Unlock Users" : "Lock Users"
										}
									>
										<i
											className={
												this.state.editing.failedAttempts >= this.props.data.Users.settings.passwords.maxFailedAttempts ? "fas fa-lock-open" : "fas fa-lock"
											}
										></i>
									</div>
									<div
										className="button"
										style={{ backgroundColor: "#2A6AA9", marginRight: "5px" }}
										onClick={this.changeRoles(this.state.editing)}
										title="Manage Roles"
									>
										<i className="fas fa-users"></i>
									</div>
									<div
										className="button"
										style={{ backgroundColor: "#2A6AA9" }}
										onClick={this.deleteUser(this.state.editing)}
										title="Delete Users"
									>
										<i className="fas fa-trash"></i>
									</div>
								</div>
							)}

							<div className="error">{this.state.error}</div>

							{this.state.loading ? (
								<div className="loader"></div>
							) : (
								<div>

									<div className="button" onClick={this.userConfirm}>
										{this.state.editing.id ? "Confirm Changes" : "Create New User"}
									</div>
								</div>
							)}

						</div>
					</div>

				)
			}
			var editRoles = ""
			if (this.state.editingRoles) {
				var roles = this.props.data.Roles
				var roleList = []
				var removeRoleList = []
				var selRoleList = []
				var addRoleList = []

				for (var role in roles) {
					if (this.state.editingRoles.roles[role] === true && this.state.rolesToRemove.indexOf(role) < 0) {
						selRoleList.push(
							<div key={role} className="dataRow" onClick={this.removeRole(role)}>{role}</div>
						)
					} else if (this.state.rolesToAdd.indexOf(role) > -1) {
						addRoleList.push(
							<div key={role} data-role={role} style={{ fontStyle: 'italic' }} className="dataRow" onClick={this.removeRole(role)}>{role}</div>
						)
					} else if (this.state.rolesToRemove.indexOf(role) > -1) {
						removeRoleList.push(
							<div key={role} data-role={role} style={{ fontStyle: 'italic' }} className="dataRow" onClick={this.addRole(role)}>{role}</div>
						)
					} else {
						roleList.push(
							<div key={role} data-role={role} className="dataRow" onClick={this.addRole(role)}>{role}</div>
						)
					}
				}
				editRoles = (
					<div className="blackout">
						<div className="pop" style={{ width: "80vw", maxWidth: "1000px" }}>
							<div className="viewCloser" onClick={this.cancel}></div>
							<div style={{ marginBottom: "25px" }}>Edit Roles for {this.state.editingRoles.wholeName}</div>
							<div style={{ display: "inline-block" }}>
								<div className="loginLabel" >Available Roles</div>
								<div id="availableRoles" className="roleBox">
									{removeRoleList}
									{roleList}
								</div>
							</div>
							<div style={{ display: "inline-block" }}>
								<div className="loginLabel" >Selected Roles</div>
								<div id="selectedRoles" className="roleBox">
									{addRoleList}
									{selRoleList}
								</div>
							</div>
							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmRoleChanges}>Confirm Roles</div>}
						</div>
					</div>
				)
			}
			var resetUser = ""
			if (this.state.resetting) {
				resetUser = (
					<div className="blackout">
						<div className="pop">
							<div className="viewCloser" onClick={this.cancel}></div>
							<div className="loginLabel">Reset the Password for {this.state.resetting.wholeName}</div>

							<div className="snazzyInputBox">
								<input className="textInput" type="text" required value={this.state.resetUserPIN} onChange={this.resetUserPINChange} ></input>
								<span className="inputBar"></span><label className="textLabel">Enter a New Password</label>
							</div>
							<div className="error">{this.state.error}</div>
							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmResetUser}>Reset Password</div>}
						</div>
					</div>
				)
			}
			var unlockUser = ""
			if (this.state.unlocking) {
				unlockUser = (
					<div className="blackout">
						<div className="pop">
							<div className="viewCloser" onClick={this.cancel}></div>
							<div className="loginLabel" style={{ marginBottom: '15px' }}>Unlock Account for {this.state.unlocking.wholeName}</div>
							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.userConfirmUnlock}>Unlock Account</div>}
						</div>
					</div>
				)
			}
			var delUser = ""
			if (this.state.deleting) {
				delUser = (
					<div className="blackout">
						<div className="pop">
							<div className="viewCloser" onClick={this.cancel}></div>
							<div>You Are Removing User</div>
							<div style={{ margin: "15px" }}> {this.state.deleting.wholeName} </div>
							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmDeleteUser}>Delete This User</div>}
						</div>
					</div>
				)
			}


			var addButton = ""
			var settingsButton = ""
			if (this.state.type === 'users' || this.state.type === 'roles') {
				addButton = <img src={this.props.img.plus} className="plusButton" alt="Add a user" onClick={this.userAdd} />
				//settingsButton = <img src={this.props.img.gear} className="plusButton2" alt="Add a user" onClick={this.settingsToggleSetting} />
			}


			return (
				<div width="100%">
					{addButton}
					{settingsButton}
					<div style={{ display: 'flex', flexWrap: 'wrap' }}>
						<div style={{ width: '280px', marginRight: '10px' }}>
							<div style={{ display: 'flex', alignItems: 'left', marginBottom: '20px', marginTop: '10px' }}>
							</div>
							<div className="filterBox">

								<h4>Filter By:</h4>
								<div style={{ width: '250px' }}>
									<label>Name:</label>
									<input type="text" onChange={this.filter("wholeName")} value={this.state.filterBy.DisplayName} />
								</div>
								<div style={{ width: '250px' }}>
									<label>Email:   </label>
									<input type="text" onChange={this.filter("email")} value={this.state.filterBy.User} />
								</div>
							</div>
						</div>
						<div style={{ flex: 1 }}>
							<table>
								<thead>
									<tr className="dataRow">
										<th style={{ minWidth: '180px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("name")}>Name {this.filterIcon("name")}</th>
										<th style={{ minWidth: '250px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("email")}>Email {this.filterIcon("email")}</th>
										<th style={{ minWidth: '150px', cursor: 'pointer', textAlign: 'right' }} onClick={this.sort("status")}>Status {this.filterIcon("status")}</th>
										<th style={{ minWidth: '200px', cursor: 'pointer', textAlign: 'right' }} onClick={this.sort("lastActivity")}>Last Activity {this.filterIcon("lastActivity")}</th>
									</tr>
								</thead>
								<tbody>
									{userList}
								</tbody>
							</table>
						</div>
					</div >
					{editSettings}
					{editUser}
					{editRoles}
					{resetUser}
					{delUser}
					{unlockUser}
				</div >
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}


}

export { Users, icon, roles }